import Notifications from './Notifications/Notifications.vue'
import Security from './Security/Security.vue'
import { MODULE, NOTIFICATIONS, PROFILE, SECURITY } from '@/constants/routes'

export default {
  components: {
    Notifications,
    Security,
  },
  data() {
    return { SECURITY, NOTIFICATIONS }
  },
}
